import * as React from "react";
import "./Upload.css";
import {
  Steps,
  Button,
  message,
  Form,
  Input,
  Select,
  Checkbox,
  Modal,
  Upload,
  Typography,
  InputNumber,
} from "antd";
import { InboxOutlined, PlusOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { axiosFetchInstance, handleUnauthorized } from "../../Axios";
import QueryString from "query-string";
const { TextArea } = Input;
const { Step } = Steps;
const { Dragger } = Upload;
const { Option } = Select;
const { Title } = Typography;
const MAX_DEMO_VIDEO_SIZE = 8 * 1024 * 1024;
const DEMO_VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|mov)$/i;

const UploadItem = () => {
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = React.useState(false);
  const [current, setCurrent] = React.useState(0);
  const [catigoriesOptions, setCatigoriesOptions] = React.useState([]);
  const [subsOptions, setSubOptions] = React.useState([]);
  const [fwOptions, setFwOptions] = React.useState([]);
  const [fileOptions, setFileOptions] = React.useState([]);
  const [prevImg, setPrevImg] = React.useState("");
  const [pervTitle, setPrevTitle] = React.useState("");
  const [pervVisible, setPrevVisible] = React.useState(false);
  const [fileList, SetFilelist] = React.useState([]);
  const [icon, setIcon] = React.useState("");
  const [preview, setPreview] = React.useState("");
  const [demoVideo, setDemoVideo] = React.useState("");
  const [productDetails, setProductDetails] = React.useState({});
  const [frameworks, setFrameworks] = React.useState({});
  const [file_types, setFile_types] = React.useState([]);
  // const [zip_file, setZip_file] = React.useState();
  const itemName = React.useRef();
  const itemShortDesc = React.useRef();
  const itemDesc = React.useRef();
  const itemFeatures = React.useRef();
  const itemDemoUrl = React.useRef();
  const itemTestApk = React.useRef();
  const itemTestIos = React.useRef();
  const itemYTurl = React.useRef();
  const itemPrice = React.useRef();
  const itemSize = React.useRef();
  const fileUrl = React.useRef();
  const location = useLocation();
  const query = QueryString.parse(location.search);

  const getUploadFile = (file) => file.originFileObj || file;
  const isEditMode = Boolean(query.item);

  const mapFrameworksByType = (selectedFrameworks) => {
    return selectedFrameworks.reduce((acc, framework) => {
      if (!acc[framework.ftype]) {
        acc[framework.ftype] = [];
      }

      acc[framework.ftype].push(framework.id);
      return acc;
    }, {});
  };

  const loadCategoryOptions = (value) => {
    return axiosFetchInstance
      .get(`/options/${value}/`)
      .then((res) => {
        setSubOptions(res.data.subcatigories);
        setFwOptions(res.data.framework_types);
        setFileOptions(res.data.file_types);
        return res.data;
      })
      .catch((error) => {
        !error.response || error.response.status === 401
          ? handleUnauthorized(error)
          : console.log(error.response);
        throw error;
      });
  };

  const validateDemoVideo = (file) => {
    const isVideo =
      (file.type && file.type.startsWith("video/")) ||
      DEMO_VIDEO_EXTENSIONS.test(file.name || "");
    const isLt8M = file.size <= MAX_DEMO_VIDEO_SIZE;

    if (!isVideo) {
      message.error("Demo video must be a video file", 5);
      return false;
    }

    if (!isLt8M) {
      message.error("Demo video must be 8 MB or less", 5);
      return false;
    }

    return true;
  };

  const beforeDemoVideoUpload = (file) => {
    return validateDemoVideo(file) ? false : Upload.LIST_IGNORE || false;
  };

  const handleDemoVideoChange = (info) => {
    const nextFile = info.fileList.slice(-1)[0];

    if (!nextFile) {
      setDemoVideo("");
      return;
    }

    if (!validateDemoVideo(getUploadFile(nextFile))) {
      setDemoVideo("");
      return;
    }

    setDemoVideo(nextFile);
  };

  const showUploadError = (error) => {
    if (!error.response || error.response.status === 401) {
      handleUnauthorized(error);
      return;
    }

    const data = error.response.data || {};
    const demoVideoError = Array.isArray(data.demo_video)
      ? data.demo_video[0]
      : data.demo_video;

    message.error(
      demoVideoError || data.error || "Could not upload item media",
      5
    );
  };

  React.useEffect(() => {
    let isMounted = true;

    const loadInitialData = async () => {
      try {
        const categoriesResponse = await axiosFetchInstance.get("/catigories/");

        if (!isMounted) {
          return;
        }

        const categories = categoriesResponse.data;
        setCatigoriesOptions(categories);

        if (!query.item) {
          form.resetFields();
          setFrameworks({});
          setFile_types([]);
          setSubOptions([]);
          setFwOptions([]);
          setFileOptions([]);
          setInitialValues({});
          return;
        }

        const itemResponse = await axiosFetchInstance.get(
          `/item-details/${query.item}/`
        );

        if (!isMounted) {
          return;
        }

        const item = itemResponse.data;
        const selectedCategory = categories.find(
          (category) => category.name === item.catigory
        );
        const selectedSubcatigory = selectedCategory?.sub_catigories.find(
          (subCategory) => subCategory.name === item.sub_catigory
        );
        const selectedFrameworks = mapFrameworksByType(item.frameworks || []);
        const selectedFileTypes = (item.file_types || []).map((file) => file.id);

        if (selectedCategory) {
          await loadCategoryOptions(selectedCategory.id);
        }

        if (!isMounted) {
          return;
        }

        const nextInitialValues = {
          name: item.name,
          short_desc: item.short_describtion,
          catigory: selectedCategory?.id,
          subcatigory: selectedSubcatigory?.id,
          file_types: selectedFileTypes,
          desc: item.describtion,
          demo_url: item.demo_url,
          test_apk: item.test_apk,
          test_ios: item.test_ios,
          youtube_url: item.youtube_url,
          size: item.size,
          features: item.featurs,
          price: item.price,
          file_url: item.file_url,
          ...selectedFrameworks,
        };

        setFrameworks(selectedFrameworks);
        setFile_types(selectedFileTypes);
        setInitialValues(nextInitialValues);
        form.resetFields();
        form.setFieldsValue(nextInitialValues);
      } catch (error) {
        console.log(error);
        !error.response || error.response.status === 401
          ? handleUnauthorized(error)
          : console.log(error.response);
      }
    };

    loadInitialData();

    return () => {
      isMounted = false;
    };
  }, [form, query.item]);

  const addItem = () => {
    let data;
    const main = new FormData();
    const hasIcon = Boolean(icon && icon.originFileObj);
    const hasPreview = Boolean(preview && preview.originFileObj);
    const hasNewDemoVideo = Boolean(demoVideo && demoVideo.originFileObj);

    if (!isEditMode && (!hasIcon || !hasPreview)) {
      message.error("please upload all requier data", 5);
      setCurrent(1);
      return;
    }

    // main.append("zip_file", zip_file, zip_file.name);
    if (hasIcon) {
      main.append("icon_img", icon.originFileObj, icon.name);
    }

    if (hasPreview) {
      main.append("preview_img", preview.originFileObj, preview.name);
    }

    if (hasNewDemoVideo) {
      const videoFile = getUploadFile(demoVideo);
      main.append("demo_video", videoFile, demoVideo.name);
    }

    if (fileList.length > 0) {
      for (let index = 0; index < fileList.length; index++) {
        main.append(
          `screen${index + 1}`,
          fileList[index].originFileObj,
          fileList[index].name
        );
      }
    }

    const nf = [];
    Object.keys(frameworks).forEach((key) => {
      frameworks[key].forEach((f) => nf.push(f));
    });
    console.log(nf);

    data = {
      name: productDetails.name,
      short_describtion: productDetails.short_describtion,
      describtion: productDetails.describtion,
      catigory: productDetails.catigory,
      sub_catigory: productDetails.subcatigory,
      featurs: productDetails.features,
      demo_url: productDetails.demo_url,
      test_apk: productDetails.test_apk,
      test_ios: productDetails.test_ios,
      youtube_url: productDetails.youtube_url,
      // size: Math.ceil(zip_file.size / 1024 / 1024),
      size: form.getFieldValue("size"),
      price: form.getFieldValue("price"),
      file_url: form.getFieldValue("file_url"),
      file_types,
      frameworks: nf,
    };

    if (query.item) {
      axiosFetchInstance
        .put(`/update-item/${query.item}/`, data)
        .then((res) => {
          axiosFetchInstance
            .put(`/update-item/${query.item}/`, main)
            .then((res) => {
              console.log(res.data);
              message.success("item updated", 3);
              setTimeout(
                () => (window.location.href = "/dashboard/myitems"),
                1000
              );
            })
            .catch((error) => {
              showUploadError(error);
            });
        })
        .catch((error) => {
          error.response.status === 401 || !error.response.status
            ? handleUnauthorized(error)
            : console.log(error.response);
          message.error("please fill in all requierd fields", 5);
          setCurrent(0);
        });
    } else {
      axiosFetchInstance
        .post("/add-item/", data)
        .then((res) => {
          axiosFetchInstance
            .put(`/update-item/${res.data.id}/`, main)
            .then((res) => {
              console.log(res.data);
              message.success("item added", 3);
              setTimeout(
                () => (window.location.href = "/dashboard/myitems"),
                1000
              );
            })
            .catch((error) => {
              showUploadError(error);
            });
        })
        .catch((error) => {
          error.response.status === 401 || !error.response.status
            ? handleUnauthorized(error)
            : console.log(error.response);
          message.error("please fill in all requierd fields", 5);
          setCurrent(0);
        });
    }
  };

  const handleSteps = (move) => {
    if (move === "next") {
      if (current === 0) {
        form
          .validateFields([
            "name",
            "short_desc",
            "catigory",
            "subcatigory",
            "desc",
            "features",
            "demo_url",
          ])
          .then((values) => {
            const selectedFrameworksCount = Object.values(frameworks).reduce(
              (count, selectedValues) => count + selectedValues.length,
              0
            );

            if (
              file_types.length < 1 ||
              (fwOptions.length > 0 && selectedFrameworksCount < 1)
            ) {
              message.error("please fill all fields", 5);
              return;
            }

            setProductDetails({
              name: values.name,
              short_describtion: values.short_desc,
              catigory: values.catigory,
              subcatigory: values.subcatigory,
              describtion: values.desc,
              features: values.features,
              demo_url: values.demo_url,
              test_apk: values.test_apk || "",
              test_ios: values.test_ios || "",
              youtube_url: values.youtube_url || "",
            });
            setCurrent(current + 1);
          })
          .catch(() => {
            message.error("please fill all fields", 5);
          });
        return;
      }
      setCurrent(current + 1);
      console.log(frameworks);
    } else setCurrent(current - 1);
  };
  //////////////  screens upload //////////////
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleCancel = () => setPrevVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPrevImg(file.url || file.preview);
    setPrevVisible(true);
    setPrevTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleChangeList = (info) => {
    SetFilelist(info.fileList);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  //////////////  screens upload //////////////

  ////////////// Icon & Preview /////////////

  ////////////// Icon & Preview /////////////

  //////// Select Options //////////
  const catigoryChange = (value) => {
    setFrameworks({});
    setFile_types([]);
    setSubOptions([]);
    setFwOptions([]);
    setFileOptions([]);
    form.setFieldsValue({
      subcatigory: undefined,
      file_types: [],
    });

    axiosFetchInstance
      .get(`/options/${value}/`)
      .then((res) => {
        console.log(res.data);
        setSubOptions(res.data.subcatigories);
        setFwOptions(res.data.framework_types);
        setFileOptions(res.data.file_types);
      })
      .catch((error) => {
        error.response.status === 401 || !error.response.status
          ? handleUnauthorized(error)
          : console.log(error.response);
      });
  };
  //////// Select Options //////////

  ////////// Checkbox Groups /////////

  const handleFiles = (values) => {
    setFile_types(values);
  };
  ////////// Checkbox Groups /////////

  const steps = [
    {
      title: "Product details",
      content: (
        <Form initialValues={initialValues} layout="vertical" form={form}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter the item name" }]}
          >
            <Input required ref={itemName} placeholder="Name" />
          </Form.Item>
          <Form.Item
            name="short_desc"
            label="Short Describtion (Max 80 Characters)"
            rules={[
              {
                required: true,
                message: "Please enter a short description",
              },
            ]}
          >
            <Input
              required
              ref={itemShortDesc}
              placeholder="Short Describtion"
            />
          </Form.Item>
          <Form.Item
            name="catigory"
            label="Catigory"
            rules={[{ required: true, message: "Please select a category" }]}
          >
            <Select
              required
              placeholder="Catigory..."
              style={{ width: "100%" }}
              onChange={catigoryChange}
            >
              {catigoriesOptions.map((c) => {
                return (
                  <Option key={c.id} value={c.id}>
                    {c.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="subcatigory"
            label="Subcatigory"
            rules={[
              { required: true, message: "Please select a subcategory" },
            ]}
          >
            <Select
              required
              disabled={subsOptions.length ? false : true}
              placeholder="subcatigory..."
              style={{ width: "100%" }}
            >
              {subsOptions.map((s) => {
                return (
                  <Option key={s.id} value={s.id}>
                    {s.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Title level={5}>Frameworks</Title>
          {fwOptions.length > 0 &&
            fwOptions.map((type, n) => {
              return (
                <Form.Item name={type.name} key={n} label={type.name}>
                  <Checkbox.Group
                    required
                    key={n + 1}
                    options={type.frameworks.map((f) => {
                      return { label: f.name, value: f.id };
                    })}
                    onChange={(value) => {
                      console.log(frameworks);
                      setFrameworks({ ...frameworks, [type.name]: value });
                    }}
                  />
                </Form.Item>
              );
            })}

          <Form.Item name="file_types" label="Files Included">
            <Checkbox.Group
              required
              options={fileOptions.map((f) => {
                return { label: f.name, value: f.id };
              })}
              onChange={handleFiles}
            />
          </Form.Item>
          <Form.Item
            name="desc"
            label="Describtion"
            rules={[
              { required: true, message: "Please enter the description" },
            ]}
          >
            <TextArea required ref={itemDesc} placeholder="Describtion" />
          </Form.Item>
          <Form.Item
            name="features"
            label="Features"
            rules={[{ required: true, message: "Please enter the features" }]}
          >
            <TextArea required ref={itemFeatures} placeholder="Features" />
          </Form.Item>
          <Form.Item
            name="demo_url"
            label="Live Demo URL: (eg. your URL or Google Drive)"
            rules={[
              { required: true, message: "Please enter the demo URL" },
            ]}
          >
            <Input
              required
              ref={itemDemoUrl}
              placeholder="example https://google.com"
              addonBefore="http://"
              addonAfter=".com"
            />
          </Form.Item>
          <Form.Item name="test_apk" label="Test APK / Google Play Link:">
            <Input
              ref={itemTestApk}
              placeholder="example https://google.com"
              addonBefore="http://"
              addonAfter=".com"
            />
          </Form.Item>
          <Form.Item name="test_ios" label="iOS Link: (optional)">
            <Input
              ref={itemTestIos}
              placeholder="example https://google.com"
              addonBefore="http://"
              addonAfter=".com"
            />
          </Form.Item>
          <Form.Item name="youtube_url" label="YouTube URL: (optional)">
            <Input
              ref={itemYTurl}
              placeholder="example https://google.com"
              addonBefore="http://"
              addonAfter=".com"
            />
          </Form.Item>
        </Form>
      ),
    },
    {
      title: "Media Assets",
      content: (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-evenly",
              padding: "1rem 0",
            }}
          >
            <div className="dragger">
              <Dragger
                beforeUpload={() => false}
                onChange={(info) => setIcon(info.file)}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to upload icon
                </p>
                <p className="ant-upload-hint">Icon Image: * (size: 200x200)</p>
              </Dragger>
            </div>
            <div className="dragger">
              <Dragger
                beforeUpload={() => false}
                onChange={(info) => setPreview(info.file)}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to upload image
                </p>
                <p className="ant-upload-hint">
                  Preview Image: * (size 590x300)
                </p>
              </Dragger>
            </div>
          </div>
          <div style={{ padding: "0 1rem 1rem" }}>
            <Dragger
              accept="video/mp4,video/webm,video/ogg,video/quicktime"
              beforeUpload={beforeDemoVideoUpload}
              fileList={demoVideo ? [demoVideo] : []}
              maxCount={1}
              onChange={handleDemoVideoChange}
              onRemove={() => setDemoVideo("")}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to upload demo video
              </p>
              <p className="ant-upload-hint">
                Demo Video: optional, max size 8 MB
              </p>
            </Dragger>
          </div>
          {!query.item && (
            <div style={{ padding: "1rem" }}>
              <Upload
                beforeUpload={() => false}
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChangeList}
              >
                {fileList.length >= 8 ? null : uploadButton}
              </Upload>
              <Modal
                visible={pervVisible}
                title={pervTitle}
                footer={null}
                onCancel={handleCancel}
              >
                <img alt="example" style={{ width: "100%" }} src={prevImg} />
              </Modal>
            </div>
          )}
        </>
      ),
    },
    {
      title: "Files & Pricing",
      content: (
        <>
          {/* <Dragger
            beforeUpload={() => false}
            onChange={(info) => setZip_file(info.file)}
            style={{ padding: "0 0.5rem" }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to upload zip</p>
            <p className="ant-upload-hint">.zip (Only)</p>
          </Dragger> */}
          <Form
            initialValues={initialValues}
            style={{ padding: "1rem 0" }}
            form={form}
            layout="vertical"
          >
            <Form.Item name="file_url" label="Source Download Url">
              <Input
                ref={fileUrl}
                placeholder="example https://google.com"
                addonBefore="http://"
                addonAfter=".com"
              />
            </Form.Item>
            <Form.Item name="size" label="File size: (size of .ZIP file in MB)">
              <InputNumber
                required
                style={{ width: "100%" }}
                ref={itemSize}
                placeholder="File Size"
                // placeholder={
                //   zip_file
                //     ? `${Math.ceil(zip_file.size / 1024 / 1024)} MB`
                //     : "File Size"
                // }
              />
            </Form.Item>

            <Form.Item name="price" label="Price: (Single Licence)">
              <InputNumber
                addonBefore="$"
                required
                ref={itemPrice}
                style={{ width: "100%" }}
              />
            </Form.Item>
            {/* <Form.Item required  label='Price: (Multiple Licence)'>
                            <InputNumber style={{width:'100%'}} />
                        </Form.Item> */}
          </Form>
        </>
      ),
    },
  ];
  return (
    <>
      <Title level={2}>{query.item ? "Edit Item" : "New Item"}</Title>
      {initialValues && (
        <div style={{ backgroundColor: "#fff", padding: "1.5rem" }}>
          <Steps current={current}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content" style={{ padding: "1rem 0" }}>
            {steps[current].content}
          </div>
          <div className="steps-action">
            {current < steps.length - 1 && (
              <Button
                htmlType="submit"
                type="primary"
                onClick={() => handleSteps("next")}
              >
                Next
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button type="primary" onClick={addItem}>
                Done
              </Button>
            )}
            {current > 0 && (
              <Button
                type="dashed"
                style={{ margin: "0 8px" }}
                onClick={() => handleSteps("prev")}
              >
                Previous
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default UploadItem;
